<template>
  <div class="variants-and-quantity">
    <div class="variants">
      <div class="variant-header">
        <div class="variant-title">
          Select Variants and Quantity
        </div>
        <Icon name="arrow-right-l-2" />
      </div>
      <div class="variant-sku-images">
        <div class="variant-sku-list-title">
          {{ skuImages[0]?.attributeNameTrans }}
          ({{ skuImages.length }}):
          <span class="suffix">{{ attributesList[0]?.tag }}</span>
        </div>
        <div class="images-list">
          <div
            v-for="(item, index) in skuImages.slice(0, 5)"
            :key="index"
            :class="{ 'active': index === 0 }"
            class="images-list-item"
          >
            <Image
              v-if="item.skuImageUrl"
              class="image"
              :src="item.skuImageUrl"
            />
            <img
              v-else
              class="image"
              src="@/assets/empty-image.svg"
              alt=""
            >
          </div>
          <div class="images-list-item more">
            <img
              src="@/assets/H5/offer/vector.svg"
              alt=""
            >
          </div>
        </div>
      </div>
      <div
        v-if="!skuImages[0]?.singleAttr"
        class="variant-sku-attributes"
      >
        <div class="variant-sku-attributes-title">
          {{ skuImages[0]?.singleAttr ? 'Quantity:' : attributesList[0]?.attributeNameTrans }}
          ({{ attributesList.length }}):
        </div>
        <div class="attributes-list">
          <div
            class="attributes-list-item"
            :class="{ 'active': index === 0 }"
            v-for="(attr, index) in attributesList.slice(0, 6)"
            :key="index"
          >
            {{ attr.valueTrans }}
          </div>
          <div class="attributes-list-item">
            <img
              src="@/assets/H5/offer/vector.svg"
              alt=""
            >
          </div>
        </div>
      </div>
    </div>
    <Delivery
      :min-delivery-time="minDeliveryTime"
      :max-delivery-time="maxDeliveryTime"
      :event="false"
    />
    <div
      @click.stop="showBGPopup = true"
      class="official-bg"
    >
      <img
        src="@/assets/offical-platform.png"
        style="width: 100%;"
        alt=""
      >
    </div>

    <Popup
      v-model:show="showBGPopup"
      teleport="body"
      position="bottom"
    >
      <BuyerGuarantee
        @close="showBGPopup = false"
      />
    </Popup>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { Image } from '@/components/Image'
import { Icon } from '@/components/Icon'
import { Popup } from '@/components/Popup'
import BuyerGuarantee from './BuyerGuarantee.vue'
import Delivery from './Delivery.vue'

defineProps({
  skuImages: {
    type: Array,
    default: () => []
  },
  attributesList: {
    type: Array,
    default: () => []
  },
  minDeliveryTime: {
    type: Number,
    default: 0
  },
  maxDeliveryTime: {
    type: Number,
    default: 0
  }
})

const showBGPopup = ref(false)

</script>

<style lang='less' scoped>
.variants-and-quantity {
  background-color: #FFFFFF;
  padding: 12px 12px 0;
  margin-top: 8px;

  .variants {
    .variant-header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .variant-title {
        color: #232323;
        font-size: 14px;
        font-family: mon-700;
      }
    }

    .variant-sku-images {
      margin-top: 12px;
      .variant-sku-list-title {
        display: flex;
        gap: 4px;
        color: #232323;
        font-size: 12px;
        font-family: mon-700;
        .suffix {
          flex: 1;
          font-family: mon-500;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .images-list {
        display: flex;
        gap: 8px;
        margin-top: 12px;
        .images-list-item {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 44px;
          height: 44px;
          border-radius: 50%;
          border: 1px solid #ebf1f5;
          &.active {
            outline: 2px solid #052784;
            outline-offset: 2px;
          }
          &.more {
            background-color: #f8f8f8;
            color: #232323;
          }
          .image {
            width: 40px;
            height: 40px;
            border-radius: 50%;
          }
        }
      }
    }

    .variant-sku-attributes {
      margin-top: 18px;
      .variant-sku-attributes-title {
        color: #232323;
        font-size: 12px;
        font-family: mon-700;
      }

      .attributes-list {
        display: flex;
        margin-top: 12px;
        gap: 8px;
        overflow-x: scroll;
        padding: 4px 0 4px 4px;
        width: calc(100% + 16px);

        .attributes-list-item {
          flex-shrink: 0;
          display: flex;
          align-items: center;
          height: 32px;
          padding: 0 12px;
          background-color: #F8F8F8;
          border-radius: 4px;
          color: #232323;
          font-size: 12px;
          font-family: mon-500;
          max-width: 190px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          &.active {
            outline: 2px solid #052784;
            outline-offset: 2px;
          }
        }
      }
    }
  }

  .official-bg {
    width: 100vw;
    height: 70px;
    margin-left: -12px;
    margin-top: 12px;
    background: linear-gradient(#e2e8fa, #ffffff)
  }
}
</style>
